<template>
  <Modal v-model="IsOpen" :closable="false" :mask-closable="false" :footer-hide="true" :width="30" :title="
      IsAdd == 1 ? '添加下级部门' : IsAdd == 2 ? '查看部门' : '编辑部门'
    ">
    <span v-if="IsAdd == 2" class="iconfont ys-iconbianji rightTop" @click="editView"></span>
    <div class="fromBox">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" label-position="top">
        <FormItem prop="dept_full_cname" label="部门全称">
          <Input class="ys_input_border_bottom" :disabled="IsAdd == 2" v-model="formValidate.dept_full_cname"
            placeholder="请输入部门全称" label="名称"></Input>
        </FormItem>
        <FormItem prop="dept_cn_name" label="部门名称">
          <Input class="ys_input_border_bottom" :disabled="IsAdd == 2" v-model="formValidate.dept_cn_name"
            placeholder="请输入部门名称" label="名称"></Input>
        </FormItem>
        <FormItem prop="dept_type1" label="部门类型">
          <Select v-model="formValidate.dept_type1" :disabled="IsAdd == 2" style="width:200px">
  	        <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
      	  </Select>
        </FormItem>
        <FormItem prop="branch_no" label="部门编号">
          <Input class="ys_input_border_bottom" :disabled="IsAdd == 2" v-model="formValidate.branch_no"
            placeholder="请输入部门编号" label="名称"></Input>
        </FormItem>
        <FormItem prop="ins_name" label="部门级别">
          <Input class="ys_input_border_bottom" :disabled="true" v-model="formValidate.dept_level" label="名称"></Input>
        </FormItem>
        <FormItem prop="ins_name" label="上级部门名称">
          <Input class="ys_input_border_bottom" :disabled="true" v-model="formValidate.super_dept_cn_name" label="名称"></Input>
        </FormItem>
      </Form>
    </div>
    <div class="modal_food">
      <Button @click="Commit" class="ys-confirm" style="margin-left:15px" v-if="IsAdd != 2">
        {{ IsAdd == 3 ? "更新" : "提交" }}
      </Button>
      <Button @click="Cancel" class="ys-cancel">{{ IsAdd == 2 ? "关闭" : "取消" }}</Button>
    </div>
  </Modal>
</template>
<script>
import { mapActions } from "vuex";
  export default {
    name: "modelInfo",
    props: {
      IsOpen: {
        type: Boolean,
        default: false
      },
      // 1 新建 2查看  3编辑
      IsAdd: {
        type: Number,
        default: 1
      },
      // 模板详情
      ModelData: {
        type: Object,
        default: {}
      },
      // 新增主页面带过来信息
      addData: {
        type: Object,
        default: {}
      },
      // 模板详情
      selectValue: {
        type: String,
        default: {}
      }
    },
    data() {
      return {
        formValidate: {
          dept_full_cname: "",
          dept_cn_name: "",
          branch_no: "",
          dept_type:''
        },
        ruleValidate: {
          dept_full_cname: [{
            required: true,
            message: "请输入部门全称",
            trigger: "blur"
          }],
          dept_cn_name: [{
            required: true,
            message: "请输入部门名称",
            trigger: "blur"
          }],
          branch_no: [{
            required: true,
            message: "请输入部门编号",
            trigger: "blur"
          }],
          dept_type1: [{
            required: true,
            message: "请选择部门类型",
            trigger: "blur"
          }],
        },
        cityList:[]
      };
    },
    mounted() {
			if(this.addData.super_dept_id){
				this.formValidate = {
					...this.formValidate,
					...this.addData,
				}
			}
			if(this.ModelData.dept_id){
				this.formValidate = {
					...this.formValidate,
					...this.ModelData,
          "dept_type1":this.ModelData.dept_type+''
				}
			}
      this.ConfigCodeView_qryConfigByType({
        "type_code":"unit",
        // "emt_id":this.selectValue
      }).then(res =>{
        let len = this.cityList.length,
            list = this.coverSelect(res.config_list,{
              "value":'con_code',
              "label":'con_value'
            })
        this.cityList.splice(0,len,...list);
      })
    },
    methods: {
      ...mapActions([
        "ConfigCodeView_qryConfigByType"
      ]),
      // 取消模态框
      Cancel() {
        this.formValidate = {
          dept_full_cname: "",
          dept_cn_name: "",
          branch_no: "",
          dept_type1:""
        };
        this.IsOpen = false;
        this.$emit("close_modal");
      },
      // 更新或确定关闭模态框
      Commit() {
        // 新增/编辑
        if (this.IsAdd == 1 || this.IsAdd == 3) {
          this.Validate();
        }
        // 查看
        if (this.IsAdd == 2) {
          this.formValidate = {
	          dept_full_cname: "",
	          dept_cn_name: "",
	          branch_no: "",
            dept_type1:''
          };
          this.$emit("close_modal");
        }
      },
      // 验证数据
      Validate() {
        let _this = this;
        this.$refs["formValidate"].validate(valid => {
          if (valid) {
            _this.$emit("save_data", _this.formValidate,function(){
              _this.formValidate = {
                dept_full_cname: "",
                dept_cn_name: "",
                branch_no: "",
                dept_type1:''
              };
            });
            
          } else {
            _this.$Message.error("请完善信息!");
          }
        });
      },
      //编辑按钮点击事件
      editView(){
      	this.IsAdd = 3;
      },
      coverSelect (selectList, map) {
        const newSelectList = []
        selectList.forEach((item) => {
          const value = item[map.value]
          const label = item[map.label]
          newSelectList.push({
            value,
            label
          })
        })
        return newSelectList;
      }
    }
  };
</script>
<style lang="less" scoped>
  .fromBox {
  width: 100%;
  margin-bottom: 15px;
  .swiperIconBox {
    width: 100%;
    height: 150px;
    padding: 5px 0 5px 5px;
    margin-top: 10px;
    border: 1px solid #d9e3f3;
  }
}
.rightTop{
	position:absolute;
	right:12px;
	top:10px;
	font-size:20px;
	cursor:pointer;
}
.modal_food {
  height: 45px;
  width: 100%;
  margin-top: 15px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-end;
}

// 设计器新增组件列表样式
.ComponetnList {
  min-height: 100px;
  width: 100%;
}

/deep/.ivu-form-item-label {
  font-size: 16px;
  color: #c6d1e2;
  &:before {
    content: "";
  }
}

/deep/.ivu-select-selection {
  height: 38px;
  line-height: 38px;
}

/deep/.ivu-select-single .ivu-select-selection .ivu-select-placeholder {
  height: 38px;
  line-height: 38px;
  font-size: 14px;
}

/deep/.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  // color: #c6d1e2;
  height: 38px;
  line-height: 38px;
  font-size: 14px;
}
.textareaBox{
  /deep/textarea{
    resize:none;
  }
}
</style>